export const NOTAPPLICABLE = 'N/A';
